<template>
  <div class="im-checkbox" :class="[{checked: isChecked}]" @click="toggle()">
    <svg>
      <use xlink:href="#icon-checkbox"></use>
    </svg>
  </div>
</template>

<script>
export default {
  name: "Checkbox",
  props: {
    checked: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isChecked: this.checked
    }
  },
  watch: {
    checked(value) {
      this.isChecked = value;
    }
  },
  methods: {
    toggle() {
      this.isChecked = !this.isChecked;
      this.$emit('change', this.isChecked);
    }
  }
}
</script>

<style lang="scss">
  .im-checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #D6D6D6;
    box-sizing: border-box;
    width: 16px;
    height: 16px;

    svg {
      display: none;
      fill: #1588E2;
      width: 8px;
      height: 7px;
    }

    &.checked {
      svg {
        display: block;
      }
    }
  }
</style>